
import { useState, useEffect } from 'react';
import { UserProfile, IntegrationProviderInfo } from '../types';
import { IntegrationService } from '../services/IntegrationService';

interface IdentityManagementProps {
    userProfile: UserProfile | null | undefined;
}

export const useIdentityManagement = ({ userProfile }: IdentityManagementProps) => {
    const [externalIdentities, setExternalIdentities] = useState<Record<string, any>>({});
    const [availableProviders, setAvailableProviders] = useState<IntegrationProviderInfo[]>([]);

    // 1. External Identities Listener
    useEffect(() => {
        if (!userProfile?.orgId) {
            setExternalIdentities({});
            return;
        }
        return IntegrationService.listenToIdentities(userProfile.orgId, setExternalIdentities);
    }, [userProfile?.orgId]);

    // 2. Providers Listener
    useEffect(() => {
        if (!userProfile?.orgId) {
            setAvailableProviders([]);
            return;
        }
        return IntegrationService.listenToProviders(setAvailableProviders);
    }, [userProfile?.orgId]);

    return {
        externalIdentities,
        availableProviders
    };
};
